import { THEME_IDS } from '@atlas/shared';
import { industrialLaserTheme } from './industrial-laser';
import { backstageSynthTheme } from './backstage-synth';
import { vhsControlRoomTheme } from './vhs-control-room';
import { riggingBayTheme } from './rigging-bay';
import { classicLightTheme } from './classic-light';
import { chauvetCorporateTheme } from './chauvet-corporate';
export const themes = {
    'industrial-laser': industrialLaserTheme,
    'backstage-synth': backstageSynthTheme,
    'vhs-control-room': vhsControlRoomTheme,
    'rigging-bay': riggingBayTheme,
    'classic-light': classicLightTheme,
    'chauvet-corporate': chauvetCorporateTheme,
};
/** Themes in the order they should appear in the picker. */
export function listThemes() {
    return THEME_IDS.map((id) => themes[id]);
}
//# sourceMappingURL=index.js.map